module.exports = {"name":"Parkway-Wabash Park","description":"Parkway-Wabash Park is a small park in Old Fourth Ward on the corner of Parkway Dr and Wabash Ave. The park has a basketball court and a small playground.","parking":"There is street parking on Parkway Dr.","hours":"6am - 11pm","location":"https://www.google.com/maps/place/Parkway-Wabash+Park,+Atlanta,+GA+30308/@33.7651124,-84.3736749,18.7z","moreInfo":"","tags":["basketball","playground"],"images":["parkway-wabash1"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/parkway-wabash.json
// module id = ./src/data/parkway-wabash.json
// module chunks = main